import React from "react"
import { Typography } from "@mui/material"
import useStyles from "./useStyle"
import InfoIcon from "@mui/icons-material/Info"
import NotificationAddIcon from "@mui/icons-material/NotificationAdd"
import { NotificationBox } from "./NotificationBox"
import { useSelector } from "react-redux"
import { getUserRoles } from "../../../utils/validateToken"

export const GlobalNotificationHome = () => {
  const classes = useStyles()
  const user = useSelector((state) => state.user)

  const isRoleOnlyRead = () => {
    const appRoles = getUserRoles(user.eAuthToken)
    if (appRoles && appRoles.length > 0) {
      return appRoles.includes("CGI.GlobalNotificationReader")
    }
    return false
  }

  return (
    <div className={classes.root}>
      {/* <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop> */}
      {/* <BreadcrumbsComponent /> */}
      <div className={classes.boxTitle}>
        <Typography className={classes.title}>
          Notificaciones globales
        </Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon
          style={{ fontSize: "2rem", color: "#00a78f", marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
          En esta sección podrá buscar y/o gestionar las notificaciones globales
          que se visualizarán en las aplicaciones.
        </Typography>
      </div>
      {!isRoleOnlyRead() && (
        <div
          className={classes.buttonCreateNotification}
          onClick={() => (window.location.href = "/globalNotification/add")}
        >
          <NotificationAddIcon style={{ color: "#008471" }} />
          <Typography className={classes.subtitle}>
            Crear una nueva notificación
          </Typography>
        </div>
      )}
      <NotificationBox />
    </div>
  )
}
